// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".syncing[data-v-1d43dff0]{-webkit-animation:rotation-data-v-1d43dff0 2s linear infinite;animation:rotation-data-v-1d43dff0 2s linear infinite}@-webkit-keyframes rotation-data-v-1d43dff0{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes rotation-data-v-1d43dff0{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);
// Exports
module.exports = exports;
